













import { Vue, Component, Prop } from "vue-property-decorator";
import { Family } from "../../models";

@Component({})
export default class FamilyItem extends Vue {
  @Prop()
  readonly family: Family;
}
